<template>
    <!-- <div class="question-container mb-3">
        <div class="form-check  text-start">            
            
            <input
                type="checkbox"
                :name="modelValue.name"
                :id="modelValue.id"                    
                class="form-check-input"
                :checked="modelValue.value"
                @change="handleChange"
            />
            <label :for="modelValue.id" class="form-check-label">
                {{ modelValue.title }}
            </label>

            <div v-if="modelValue.error" class="text-start text-danger">{{ modelValue.error }}</div>
        </div>
    </div> -->
    <v-checkbox
        :label="modelValue.title"
        :name="modelValue.name"
        :id="modelValue.id"                    
        :model-value="modelValue.value"
        @update:model-value="handleChange" 
        :error-messages="modelValue.error"
        >        
        <template v-slot:append-inner v-if="modelValue.mandatory">
            <v-icon color="red">mdi-asterisk</v-icon>
        </template>
    </v-checkbox>
</template>
<script>

export default {
    name: 'CheckboxComponent',

    props: ['modelValue',], //modelValue - it the name of the prop that will be used for v-model binding (from parent component)
    emits: ['update:modelValue'],

    data() {
        return {
            
        };
    },

    methods: {
        handleChange(newValue) {
            this.$emit('update:modelValue', {
                ...this.modelValue,
                value: newValue,
                error: '', // Reset any previous error
            });
        }
    }

}
</script>

<style scoped>

</style>